import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, Button, DialogContent, DialogTitle } from '@material-ui/core'

const AddBlockDialog = ({
    dialog,
    setDialog,
    showMasterDelivery,
    showMigration,
    createBlock,
    showRestore,
    showProxyRegeneration
}) => {
    const handleCreateBlock = (type) => {
        createBlock(type)
        setDialog(false)
    }

    return (
        <Dialog
            open={dialog}
            onClose={() => setDialog(false)}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>New block</DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Button
                        style={{ marginBottom: 12 }}
                        variant="contained"
                        color="primary"
                        onClick={() => handleCreateBlock('transaction')}
                    >
                        Transaction
                    </Button>

                    {showMasterDelivery ? (
                        <Button
                            style={{ marginBottom: 12 }}
                            variant="contained"
                            color="primary"
                            onClick={() => handleCreateBlock('masterDelivery')}
                        >
                            Master delivery
                        </Button>
                    ) : null}

                    {showMigration ? (
                        <Button
                            style={{ marginBottom: 12 }}
                            variant="contained"
                            color="primary"
                            onClick={() => handleCreateBlock('migration')}
                        >
                            Migration
                        </Button>
                    ) : null}

                    {showRestore ? (
                        <Button
                            style={{ marginBottom: 12 }}
                            variant="contained"
                            color="primary"
                            onClick={() => handleCreateBlock('restore')}
                        >
                            Restore
                        </Button>
                    ) : null}

                    {showProxyRegeneration ? (
                        <Button
                            style={{ marginBottom: 12 }}
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                handleCreateBlock('proxyRegeneration')
                            }
                        >
                            Proxy regeneration
                        </Button>
                    ) : null}
                </div>
            </DialogContent>
        </Dialog>
    )
}

AddBlockDialog.defaultProps = {
    showMasterDelivery: true,
    showMigration: true
}

AddBlockDialog.propTypes = {
    dialog: PropTypes.bool.isRequired,
    setDialog: PropTypes.func.isRequired,
    createBlock: PropTypes.func.isRequired,
    showMasterDelivery: PropTypes.bool,
    showMigration: PropTypes.bool
}

export default AddBlockDialog
